import { Grid } from '@mui/material';
import Box from '@mui/material/Box';
import Fade from '@mui/material/Fade';
import Typography, { TypographyProps } from '@mui/material/Typography';

type EmptyPlaceholderProps = {
  message?: string;
  width?: number;
  height?: number;
  src?: string;
  padding?: number;
  paddingY?: number;
  typographyProps?: TypographyProps;
};

const EmptyPlaceholder = ({
  message = 'Lista vazia',
  width = 250,
  height = 250,
  padding = 3,
  paddingY = 5,
  src = '/images/empty.svg',
  typographyProps,
}: EmptyPlaceholderProps) => (
  <Box
    sx={{
      padding: padding,
      paddingY: paddingY,
    }}
  >
    <Fade in>
      <Grid
        container
        sx={{
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Grid>
          <img src={src} alt="Lista teceo vazia" width={width} height={height} />
        </Grid>
        <Grid size={12}>
          <Typography variant="h4" color="textSecondary" align="center" {...typographyProps}>
            {message}
          </Typography>
        </Grid>
      </Grid>
    </Fade>
  </Box>
);

export default EmptyPlaceholder;
